module.exports = __webpack_public_path__ + "static/media/geomatex.c7741279.png";